"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTable = exports.CheckCellWrapper = exports.TableCell = exports.TableHeader = exports.TableRow = exports.TableHeaders = exports.TableHead = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.TableHead = styled_components_1.default.thead(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.concrete;
});
exports.TableHeaders = styled_components_1.default.tr(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-top: 1px solid ", ";\n  border-inline-start: 1px solid ", ";\n  border-inline-end: 1px solid ", ";\n  display: flex;\n  :last-child {\n    border-bottom: 1px solid ", ";\n  }\n"], ["\n  border-top: 1px solid ", ";\n  border-inline-start: 1px solid ", ";\n  border-inline-end: 1px solid ", ";\n  display: flex;\n  :last-child {\n    border-bottom: 1px solid ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.mercury;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.mercury;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.mercury;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.mercury;
});
exports.TableRow = styled_components_1.default.tr(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-bottom: 1px solid ", ";\n  border-inline-start: 1px solid ", ";\n  border-inline-end: 1px solid ", ";\n  display: flex;\n"], ["\n  border-bottom: 1px solid ", ";\n  border-inline-start: 1px solid ", ";\n  border-inline-end: 1px solid ", ";\n  display: flex;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.mercury;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.mercury;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.mercury;
});
exports.TableHeader = styled_components_1.default.th(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: ", ";\n  border-inline-end: 1px solid ", ";\n  white-space: nowrap;\n  flex-grow: ", ";\n"], ["\n  padding: ", ";\n  border-inline-end: 1px solid ", ";\n  white-space: nowrap;\n  flex-grow: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.small;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.mercury;
}, function (_a) {
    var flexGrow = _a.flexGrow;
    return flexGrow !== null && flexGrow !== void 0 ? flexGrow : 1;
});
exports.TableCell = styled_components_1.default.td(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding: ", ";\n  border-inline-end: 1px solid ", ";\n  white-space: nowrap;\n  flex-grow: ", ";\n"], ["\n  padding: ", ";\n  border-inline-end: 1px solid ", ";\n  white-space: nowrap;\n  flex-grow: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.small;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.mercury;
}, function (_a) {
    var flexGrow = _a.flexGrow;
    return flexGrow !== null && flexGrow !== void 0 ? flexGrow : 1;
});
exports.CheckCellWrapper = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  flex-grow: 0;\n  display: inline-block;\n  box-sizing: border-box;\n  padding: 10px;\n  width: 35px;\n"], ["\n  flex-grow: 0;\n  display: inline-block;\n  box-sizing: border-box;\n  padding: 10px;\n  width: 35px;\n"])));
exports.StyledTable = styled_components_1.default.table(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  border-spacing: unset;\n  width: 100%;\n"], ["\n  border-spacing: unset;\n  width: 100%;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
